import MirumBtn from "components/MirumBtn";
import React from "react";
import { Animated } from "react-animated-css";
import { BsXLg } from "react-icons/bs";
const MirumModal = ({
  show,
  onDidDismiss,
  children,
  onPositiveBtnClick,
  onNegativeBtnClick,
  positiveBtnBody,
  negativeBtnText,
  disablePositiveBtn,
  hideNegativeBtn,
  dontShowFooter,
  className,
  footerClassName,
}) => {
  return show ? (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-25 z-[101] flex justify-center items-center">
      <Animated animationIn="pulse" className="w-full flex justify-center">
        <div
          className={`rounded-xl bg-white w-11/12 md:w-1/2 flex flex-col justify-center items-center text-center p-4 shadow-xl ${className} relative`}
        >
          <div
            className="absolute top-0 right-0 p-8 z-50 cursor-pointer"
            onClick={onDidDismiss}
          >
            <BsXLg style={{ fontSize: "24px" }} />
          </div>
          <div className="grow pt-12 lowercase max-h-[80vh] overflow-y-auto">
            {children ? children : <h1>No content</h1>}
          </div>
          {!dontShowFooter && (
            <div
              className={`flex py-4 px-2 gap-4 w-full lowercase ${footerClassName}`}
            >
              {!hideNegativeBtn && (
                <MirumBtn
                  onClick={
                    onNegativeBtnClick ? onNegativeBtnClick : onDidDismiss
                  }
                  useNegativeStyle={true}
                >
                  {negativeBtnText ? negativeBtnText : "Cancel"}
                </MirumBtn>
              )}
              <MirumBtn
                onClick={onPositiveBtnClick}
                disabled={disablePositiveBtn}
              >
                {positiveBtnBody ? positiveBtnBody : "Ok"}
              </MirumBtn>
            </div>
          )}
        </div>
      </Animated>
    </div>
  ) : null;
};

export default MirumModal;
